import type { Banner } from '../types/landing'

export const banners: Banner[] = [
  {
    id: 'elige',
    image: 'https://cdn.magicpatterns.com/uploads/j47W8VgPaQXbdNi7pqbdwd/Elige.webp',
    alt: 'Elige la Junta Directiva de la Cámara de Comercio de Cali, período 2027-2030. Vota Lista No. 1 el jueves 3 de diciembre de 2026.',
  },
  {
    id: 'lista',
    image: 'https://cdn.magicpatterns.com/uploads/ePotC4AxdyC3cvnZ7bo3F7/Lista.webp',
    alt: 'Experiencia y criterio al servicio de la región. ¡Llegamos, aportamos, continuamos! Junta Directiva de la Cámara de Comercio de Cali 2027-2030.',
  },
  {
    id: 'tu-voto-cuenta',
    image: 'https://cdn.magicpatterns.com/uploads/aEzsZvdWRCw7pvb6zMyD2z/Tu_voto_cuenta.webp',
    alt: '¡Tu voto cuenta! Participa y elige la Junta Directiva de la Cámara de Comercio de Cali 2027-2030. Vota Lista No. 1.',
  },
]
